"use client";
import { ChipButton } from "./chipButton.js";
import { ChipCheckbox } from "./chipCheckbox.js";
import { ChipRadio } from "./chipRadio.js";
import { ChipRemovable } from "./chipRemovable.js";
const Chip = {
    Button: ChipButton,
    Checkbox: ChipCheckbox,
    Radio: ChipRadio,
    Removable: ChipRemovable,
};
Chip.Button.displayName = "Chip.Button";
Chip.Checkbox.displayName = "Chip.Checkbox";
Chip.Radio.displayName = "Chip.Radio";
Chip.Removable.displayName = "Chip.Removable";
export { Chip, ChipButton, ChipCheckbox, ChipRadio, ChipRemovable, };
//# sourceMappingURL=index.js.map